import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgBusinessPeople = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <g fill="currentColor" fillRule="nonzero">
      <path d="M12 1a5 5 0 1 0 0 10 5 5 0 0 0 0-10Zm0 2a3 3 0 1 1 0 6 3 3 0 0 1 0-6ZM12 12c5.523 0 10 4.477 10 10a1 1 0 0 1-2 0 8 8 0 0 0-16 0 1 1 0 0 1-2 0c0-5.523 4.477-10 10-10Z" />
      <path d="m11.044 12.706-2 6.5a1 1 0 0 0 .175.919l2 2.5a1 1 0 0 0 1.562 0l2-2.5a1 1 0 0 0 .175-.92l-2-6.5c-.29-.94-1.622-.94-1.912 0ZM12 16.399l.888 2.889L12 20.399l-.889-1.111.889-2.889Z" />
    </g>
  </svg>
)

const ForwardRef = forwardRef(SvgBusinessPeople)
const Memo = memo(ForwardRef)
export default Memo
